<template>
  <div>
    <section class="principal">
      <h3>Cadastro Portal API - Carga de Catálogo e Serviço</h3>
      <hr class="divider" />
      <div class="tabs">
        <button
          :class="{ 'active-tab': activeTab === 'download' }"
          @click="activeTab = 'download'"
        >
          Download
        </button>
        <button
          :class="{ 'active-tab': activeTab === 'upload' }"
          @click="activeTab = 'upload'"
        >
          Upload
        </button>
      </div>

      <div class="container-items-dropdown">
        <div v-if="activeTab === 'download'" class="center-content">
          <div class="filtro-situacao">
            <div class="container-dropdown">
              <label class="label-filtro label-tipo-servico"
                >Tipo de Serviço:
              </label>
              <select
                @click="onDropdownChange($event)"
                v-model="tipoServico"
                class="form-select dropdown-tipo-catalogo"
              >
                <option value="V">Venda</option>
                <option value="G">Gestão Carteira</option>
                <option value="P">Pós Venda</option>
              </select>
            </div>
            <div v-if="abrirComboCatalogo === true" class="container-dropdown">
              <label class="label-filtro">Catálogo: </label>
              <select
                v-model="selectedCatalogo"
                class="form-select"
                @change="carregarServicos"
              >
                <option
                  v-for="catalogo in catalogos"
                  :key="catalogo.idCatalogoApi"
                  :value="catalogo.idCatalogoApi"
                >
                  {{ catalogo.nome }}
                </option>
              </select>
              <div class="container-botao">
                <button @click="baixarCatalogo" class="carregarDados">
                  <i class="fa fa-download"></i> Baixar Catálogo
                </button>
              </div>
            </div>
            <div v-if="abrirComboServico === true" class="container-dropdown">
              <label class="label-filtro">Serviço: </label>
              <select v-model="selectedServico" class="form-select">
                <option
                  v-for="servico in servicos"
                  :key="servico.idServicoApi"
                  :value="servico.idServicoApi"
                >
                  {{ servico.nome }}
                </option>
              </select>
              <div class="container-botao">
                <button @click="baixarServico" class="carregarDados">
                  <i class="fa fa-download"></i> Baixar Serviço
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="activeTab === 'upload'" class="center-content">
          <div class="filtro-situacao">
            <div class="container-dropdown">
              <label class="label-filtro label-tipo-servico"
                >Tipo de Upload:
              </label>
              <select
                v-model="tipoUpload"
                class="form-select dropdown-tipo-catalogo"
              >
                <option value="catalogo">Catálogo</option>
                <option value="servico">Serviço</option>
              </select>
            </div>
            <div class="container-botao">
              <label class="input-upload">
                Escolher arquivo
                <input type="file" @change="uploadPlanilha" />
              </label>
              <span v-if="selectedFileName">{{ selectedFileName }}</span>
            </div>
            <div class="container-botao">
              <button
                @click="salvarPlanilha"
                class="carregarDados"
                :disabled="!selectedFileName"
              >
                <i class="fa fa-save"></i> Salvar Planilha
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="loader">
        <div>
          <div class="spinner-border"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import * as alertUtils from "@/utils/alert";
import * as loaderUtils from "@/utils/loader";

export default {
  data() {
    return {
      activeTab: "download",
      abrirComboCatalogo: false,
      abrirComboServico: false,
      tipoServico: "",
      catalogos: [],
      selectedCatalogo: "",
      servicos: [],
      selectedServico: "",
      tipoUpload: "catalogo",
      selectedFileName: "",
      uploadedFile: null,
    };
  },
  methods: {
    onDropdownChange(event) {
      if (event.target.value !== "") {
        this.tipoServico = event.target.value;
        console.log("ver o event:", event.target.value);

        this.carregarCatalogos(this.tipoServico);
      }
    },
    carregarCatalogos(tipoServico) {
      loaderUtils.addLoarder();
      this.abrirComboCatalogo = false;
      this.abrirComboServico = false;
      axios
        .get(
          `/massificados/corporativo/gerenciador-parceiros/rest/catalogo-api/consultar-grupo/${tipoServico}`
        )
        .then((response) => {
          (this.catalogos = response.data),
            loaderUtils.removeLoader(),
            (this.abrirComboCatalogo = true);
          this.abrirComboServico = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar catálogos:", error);
          alertUtils.alertError("Erro ao carregar catálogos:" + error);
          loaderUtils.removeLoader();
        });
    },
    carregarServicos() {
      loaderUtils.addLoarder();
      this.abrirComboServico = false;
      axios
        .get(
          `/massificados/corporativo/gerenciador-parceiros/rest/servico-api/consultar-catalogo/${this.selectedCatalogo}`
        )
        .then((response) => {
          this.servicos = response.data.map((servico) => ({
            idServicoApi: servico.idServicoApi,
            nome: servico.menu, // Usando o campo 'menu' como o nome do serviço
          }));
          this.abrirComboServico = true;
          loaderUtils.removeLoader();
        })
        .catch((error) => {
          console.error("Erro ao carregar catálogos:", error);
          alertUtils.alertError("Erro ao carregar serviços:" + error);
          loaderUtils.removeLoader();
        });
    },
    baixarCatalogo() {
      const url = `/massificados/corporativo/gerenciador-parceiros/rest/catalogo-api/download/${this.selectedCatalogo}`;
      this.baixarArquivo(url, "catalogo.xlsx");
    },
    baixarServico() {
      const url = `/massificados/corporativo/gerenciador-parceiros/rest/servico-api/download/${this.selectedServico}`;
      this.baixarArquivo(url, "servico.xlsx");
    },
    baixarArquivo(url, filename) {
      loaderUtils.addLoarder();
      axios
        .get(url, { responseType: "blob" })
        .then((response) => {
          loaderUtils.removeLoader();
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          link.click();
        })
        .catch((error) => {
          loaderUtils.removeLoader();
          console.error("Erro ao carregar catálogos:", error);
          alertUtils.alertError("Erro ao baixar arquivo:" + error);
          loaderUtils.removeLoader();
        });
    },
    uploadPlanilha(event) {
      const file = event.target.files[0];
      this.selectedFileName = file.name; // Atualiza o nome do arquivo selecionado
      this.uploadedFile = file;
    },
    salvarPlanilha() {
      loaderUtils.addLoarder();
      if (!this.uploadedFile) return;

      const formData = new FormData();
      formData.append("file", this.uploadedFile);

      const url =
        this.tipoUpload === "catalogo"
          ? `/massificados/corporativo/gerenciador-parceiros/rest/catalogo-api/upload-catalogo`
          : `/massificados/corporativo/gerenciador-parceiros/rest/servico-api/upload-servico`;

      axios
        .post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          loaderUtils.removeLoader();
          this.selectedFileName = "";
          this.uploadedFile = null;
          loaderUtils.removeLoader();
        })
        .catch((error) => {
          loaderUtils.removeLoader();
          console.error("Erro ao fazer upload da planilha:", error);
          alertUtils.alertError("Erro ao fazer upload da planilha:" + error);
          loaderUtils.removeLoader();
        });
    },
  },
};
</script>

<style scoped>
@import "/massificados/corporativo/gerenciador-parceiros-ui/carga-catalogo/css/style.css";
</style>
